import { render, staticRenderFns } from "./alarm-status-chip-with-relations.vue?vue&type=template&id=2171ff6a&"
import script from "./alarm-status-chip-with-relations.vue?vue&type=script&lang=js&"
export * from "./alarm-status-chip-with-relations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports